// extracted by mini-css-extract-plugin
export default {"action":"modal_action__EgTt3"};